(function () {
    'use strict';

    angular
        .module('Lavpop-store.directives')
        .directive('productAmount', ProductAmount)

    /** @ngInject */
    function ProductAmount(PATHS) {
        function ProductAmountController() {}

        function link(scope, attrs, elem, ctrl) {
            if (!ctrl.amount) ctrl.amount = 0;
            if (!ctrl.step) ctrl.step = 0;
            if (!ctrl.min) ctrl.min = 1;
            if (!ctrl.max) ctrl.max = 1;

            ctrl.amount = parseInt(ctrl.amount, 10);
            ctrl.step = parseInt(ctrl.step, 10);
            ctrl.min = parseInt(ctrl.min, 10);
            ctrl.max = parseInt(ctrl.max, 10);
        }

        return {
            bindToController: true,
            controller: ProductAmountController,
            controllerAs: 'vm',
            link: link,
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/product-amount/product-amount.html`,
            scope: {
                amount: '=',
                step: '@',
                min: '@',
                max: '@',
                onChange: '&'
            }
        }
    }
}());